// Within this many bars of the oldest one in view, the next older bars are brought in, so a steady
// pan back keeps finding candles rather than meeting the edge (DWLF-426).
export const OLDEST_CANDLE_MARGIN_BARS = 30;

/**
 * What a chart viewport change asks for: 'widen' when the view is near the start of a trailing
 * window that holds fewer bars than are loaded (mobile), 'fetch' when it is near the oldest bar
 * loaded, otherwise null.
 */
export function olderHistoryStep(viewport, shownBars, loadedBars) {
  if (!viewport || !(viewport.startIndex <= OLDEST_CANDLE_MARGIN_BARS)) {
    return null;
  }
  return shownBars < loadedBars ? 'widen' : 'fetch';
}
